<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-content text-center">
      <div class="logo-wrapper mb-4">
        <img
          :src="require('@/assets/img/auth/MI-chao_logo_icon.png')"
          alt="Loading..."
          class="cat-logo"
        />
      </div>
      <div class="loading-text">
        {{ loadingText }}
        <span class="fancy-dots">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessingOverlay',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    loadingText: {
      type: String,
      default: 'システム処理中です',
    },
  },
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 🎯 透過ベース */
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  color: #fff;
  text-align: center;
}

/* ロゴのラッパー */
.logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 100px;
}

/* ネコロゴ */
.cat-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;

  /* 🎯 コロコロ回転アニメーション */
  animation: rollCat 2.4s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}

/* 🎯 コロコロ転がる + バウンド */
@keyframes rollCat {
  0% {
    transform: translateX(-120px) rotate(-360deg) scale(0.8);
    opacity: 0;
  }

  25% {
    transform: translateX(-40px) rotate(-180deg) scale(1);
    opacity: 1;
  }

  50% {
    transform: translateX(0px) rotate(0deg) scale(1.1);
  }

  65% {
    transform: translateX(10px) rotate(30deg) scale(0.95);
  }

  80% {
    transform: translateX(-5px) rotate(-10deg) scale(1.02);
  }

  100% {
    transform: translateX(0px) rotate(0deg) scale(1);
  }
}

/* テキスト */
.loading-text {
  font-size: 16px;
  letter-spacing: 0.05em;
  margin-top: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* ドット */
.fancy-dots {
  display: inline-flex;
  gap: 4px;
}

.fancy-dots span {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;

  animation: bounceDots 1.4s infinite ease-in-out;
}

.fancy-dots span:nth-child(1) {
  animation-delay: 0s;
}
.fancy-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.fancy-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounceDots {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}
</style>
